
import { Component, Vue, Prop } from 'vue-property-decorator'
import { BytedIconMore } from '@byte-design/vue-icons'

@Component({
  name: 'NotificationListItem',
  components: { BytedIconMore },
})
export default class NotificationListItem extends Vue {
	@Prop({ type: String, default: '' }) readonly title!: string;
	@Prop({ type: String, default: '' }) readonly tag!: string;
	@Prop(String) readonly date!: string;
	@Prop({ type: Boolean, default: false }) readonly read!: boolean;

	onOpt() {
	  this.$emit('opt')
	}

	onItemClick(){
	  this.$emit('item-click')
	}
}
